import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import cx from "classnames";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles from "assets/jss/material-dashboard-react/views/modalStyle";
import OrnamentTable from "./OrnamentTable";

const useStyles = makeStyles(styles);


const OrnamentTableModal = ({
    showModal,
    closeModal,
    showUpload,
    setShowUpload,
    editable,
    getOrnamentData,
    handleChange,
    lastIndex,
    groupDetails,
    updateOrnamentDetails,
    onClickDeleteData,
    tableData,
    ornamentList,
    handleOrnamentValue,
    handleStoneWeight,
    handleOrnamentCount,
    handleCalculateWeight,
    packetError,
    handleDeductionUpdate,
    ornamentValues,
    availablePacketNumber,
    alreadyPacket,
    childClasses,
    enabelPacketNumber,
    setGroupDetails,
    setLastIndex,
    addNextRow,
    editIndex,
    editIndexData,
    showDeleteButton,
    checkForAuditedFlagOrnamentFlag,
    userDetails,
    groupDetailsOriginal,
    enabledValidationForRepledgeOrnament,
    toastUpdate,
    enabledSamePacketNumberOrnamentCheck,
    loanType,
    enabledLeadValidateForNewLoan,
    minNetWeightValue,
    featureFlags,
    subStatus,
    disableExistingOrnamentFields,
    blurCompletedRef,
  }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Dialog
        classes={{ root: classes.center }}
        maxWidth="md"
        open={showModal}
        // fullScreen
        disableEscapeKeyDown
        keepMounted
        aria-labelledby="app-journey-modal-title"
        aria-describedby="app-journey-modal-description"
        style={{maxWidth:'800px', margin:'auto', height:'70%'}}
      >
        <DialogContent
          id="app-journey-modal-description"
          className={cx(classes.modalBody, classes.loginMaxWidth)}
          style={{overflowY:'auto'}}
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
                <OrnamentTable
                    showUpload={showUpload}
                    setShowUpload={setShowUpload}
                    editable={editable}
                    getOrnamentData={getOrnamentData}
                    handleChange={handleChange}
                    lastIndex={lastIndex}
                    groupDetails={groupDetails}
                    updateOrnamentDetails={updateOrnamentDetails}
                    tableData={tableData}
                    ornamentList={ornamentList}
                    handleOrnamentValue={handleOrnamentValue}
                    handleStoneWeight={handleStoneWeight}
                    handleOrnamentCount={handleOrnamentCount}
                    handleCalculateWeight={handleCalculateWeight}
                    packetError={packetError}
                    handleDeductionUpdate={handleDeductionUpdate}
                    ornamentValues={ornamentValues}
                    availablePacketNumber={availablePacketNumber}
                    alreadyPacket={alreadyPacket}
                    classes={childClasses}
                    enabelPacketNumber={Number(enabelPacketNumber)}
                    closeModal={closeModal}
                    setGroupDetails={setGroupDetails}
                    setLastIndex={setLastIndex}
                    addNextRow={addNextRow}
                    editIndex={editIndex}
                    editIndexData={editIndexData}
                    showDeleteButton={showDeleteButton}
                    checkForAuditedFlagOrnamentFlag={checkForAuditedFlagOrnamentFlag}
                    userDetails={userDetails}
                    enabledValidationForRepledgeOrnament={enabledValidationForRepledgeOrnament}
                    groupDetailsOriginal={groupDetailsOriginal}
                    toastUpdate={toastUpdate}
                    enabledSamePacketNumberOrnamentCheck={enabledSamePacketNumberOrnamentCheck}
                    loanType={loanType}
                    enabledLeadValidateForNewLoan={enabledLeadValidateForNewLoan}
                    minNetWeightValue={minNetWeightValue}
                    featureFlags={featureFlags}
                    subStatus={subStatus}
                    disableExistingOrnamentFields={disableExistingOrnamentFields}
                    blurCompletedRef={blurCompletedRef}
                />
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
};

OrnamentTableModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  loanApplicationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loanApplicationNumber: PropTypes.string,
  editable: PropTypes.bool,
  newCustomer: PropTypes.any,
  onNewCustomer: PropTypes.func,
  documentLink: PropTypes.func,
  existdocumentLink: PropTypes.any,
  status: PropTypes.string,
  subStatus: PropTypes.string,
  loanType: PropTypes.string,
  mobileNum: PropTypes.string,
  totalCollateralValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mandatory: PropTypes.bool,
  level: PropTypes.string,
  enabledInsurance: PropTypes.bool,
  initiatorType: PropTypes.string,
  personalLoan: PropTypes.bool,
  leadBranchCode: PropTypes.string,
  seletedBranchCode: PropTypes.string,
  loanAccountNumber: PropTypes.string,
};

export default OrnamentTableModal;
